enum AbuseSurvey {
    'last_treatment_less_2_years',
    'last_treatment_more_2_years',
}

enum AstmaSurvey {
    'hospitalized_last_5_years',
    'not_hospitalized_last_5_years',
}

enum CancerSurvey {
    'basal_cell_yes',
    'basal_cell_no_last_treatment_more_2_years',
    'basal_cell_no_last_treatment_less_2_years',
    'basal_cell_no_last_treatment_more_2_years_and_less_10_years',
}

enum PsychologicalDisorder {
    Anxiery = 'anxiety',
    Bipolar = 'bipolar',
    Depression = 'depression',
    Schizophrenia = 'schizophrenia',
}

enum PsychologicalSurvey {
    '(anxiety_or_depression_or_(anxiety_and_depression))_and_no_hospitalization_and_lt_3_medications',
    'bipolar_and_no_hospitalization_and_lt_3_medications',
    '(schizophrenia_or_any_combo_other_than_anxiety_and_depression)_or_hospitalization_or_gte_3_medications',
}

enum DiabetesType {
    'Type 1' = 'type1',
    'Type 2' = 'type2',
}

enum DiabetesTreatment {
    DietExercise = 'diet_exercise',
    Medication = 'medication',
    Insulin = 'insulin',
}

enum DiabetesTreatmentForHubspot {
    'diet_exercise' = 'Dietexerciseonly',
    'medication' = 'Medication',
    'insulin' = 'Insulin',
}

enum DiabetesSurvey {
    'type_1_and_a1c_lte_8_and_not_insulin',
    'type_1_and_(a1c_gt_8_or_insulin)',
    'type_2_and_a1c_lt_10_and_not_insulin',
    'type_2_and_(a1c_gte_10_or_insulin)',
}

enum HeartAttackSurvey {
    'last_incident_lt_2_years',
    'last_incident_gt_2_years',
}

enum HighBloodPressureSurvey {
    'medications_lte_3',
    'medications_gt_3',
}

enum CholesterolSurvey {
    'ratio_gte_10',
    'ratio_lt_10_or_unknown',
}

enum SleepApneaLevel {
    mild = 'mild',
    moderate = 'moderate',
    severe = 'severe',
}

enum SleepApneaSurvey {
    'cpap_or_mild',
    'not_cpap_and_(moderate_or_severe)',
}

enum StrokeSurvey {
    'last_incident_lt_2_years',
    'last_incident_gt_2_years',
}

enum DUISurvey {
    'lt_2_years',
    'gt_2_years',
    'lt_5_years',
    'gt_5_years',
    'lt_5_years_and_gt_2_years',
}

enum MovingViolatioSurvey {
    'lt_3',
    'gte_3',
}

enum Conditions {
    Abuse = 'Alcohol/drug abuse',
    Asthma = 'Asthma',
    Cancer = 'Cancer',
    Cholesterol = 'High cholesterol',
    Psychological = 'Psychological disorder',
    Diabetes = 'Diabetes',
    HeartAttack = 'Heart attack',
    HighBloodPressure = 'High blood pressure',
    SleepApnea = 'Sleep apnea',
    Stroke = 'Stroke',
    OtherCondition = 'Other serious condition',
    DUI = 'DUI',
    MovingViolations = 'Moving violations',
    Smoking = 'Smoking',
}

const ConditionsForHubspot = {
    alcohol: 'Alcohol abuse',
    drugs: 'Drug abuse',
    astma: 'Asthma',
    cancer: 'Cancer',
    cholesterol: 'High cholesterol',
    psychological: 'Psychological disorder',
    diabetes: 'Diabetes',
    heart_attack: 'Heart attack',
    high_blood_pressure: 'High blood pressure',
    sleep_apnea: 'Sleep apnea',
    stroke: 'Stroke',
    other_condition: 'Other serious condition',
};

export {
    AbuseSurvey,
    AstmaSurvey,
    CancerSurvey,
    PsychologicalDisorder,
    PsychologicalSurvey,
    DiabetesTreatment,
    DiabetesType,
    DiabetesSurvey,
    HeartAttackSurvey,
    HighBloodPressureSurvey,
    CholesterolSurvey,
    SleepApneaLevel,
    SleepApneaSurvey,
    StrokeSurvey,
    DUISurvey,
    MovingViolatioSurvey,
    Conditions,
    DiabetesTreatmentForHubspot,
    ConditionsForHubspot,
};
